
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cx6DD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $011685d5893c339e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $011685d5893c339e$export$2e2bcd8739ae039 = {
    'confluence.error.panel.refresh.app': "Aggiorna l'app",
    'confluence.error.panel.reload.page': 'Ricarica la pagina',
    'confluence.icon.label': 'Icona',
    'confluence.modal.dialog.close.modal.button': 'Annulla',
    'confluence.select.required.field.message': "Questo campo \xe8 obbligatorio.",
    'confluence.text.area.required.field.message': "Questo campo \xe8 obbligatorio.",
    'confluence.textfield.validator.email': 'Inserisci un indirizzo e-mail valido.',
    'confluence.textfield.validator.number': 'Inserisci un numero valido',
    'confluence.textfield.validator.required.field.message': "Questo campo \xe8 obbligatorio.",
    'confluence.textfield.validator.telephone': 'Inserisci un numero di telefono valido.',
    'confluence.threeLOPrompt.modal.access.required.title': 'Accesso necessario',
    'confluence.threeLOPrompt.modal.error.title': 'Errore',
    'confluence.threeLOPrompt.modal.no.authURL.error-message': 'URL di autorizzazione non trovato. Aggiorna la pagina e riprova.',
    'confluence.threeLOPrompt.no.authURL.error-message': 'URL di autorizzazione non trovato. Aggiorna la pagina e riprova.',
    'confluence.threeLOPrompt.use-auth.allow.access.button.text': "Consenti l'accesso",
    'confluence.threeLOPrompt.use-auth.configure.access.button.text': "Configura l'accesso",
    'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message': 'Autenticazione non riuscita.',
    'confluence.threeLOPrompt.use-auth.default.prompt.message': "Per visualizzare {appString}, devi consentire all'app di accedere ai prodotti per tuo conto.",
    'confluence.threeLOPrompt.use-auth.external.auth.prompt.message': '{appString} richiede un accesso aggiuntivo al tuo account.',
    'confluence.threeLOPrompt.use-auth.external.auth.warning.message': 'Avviso di autenticazione esterna',
    'confluence.threeLOPrompt.use-auth.this.app.lower.message': "quest'app",
    'confluence.threeLOPrompt.use-auth.this.app.upper.message': "Quest'app",
    'confluence.user.group.unknown.user.message': 'Utente sconosciuto',
    'confluence.user.picker.empty.field.error.message': "Questo campo \xe8 obbligatorio.",
    'confluence.user.unknown.user.message': 'Utente sconosciuto',
    'forge-ui.form.submit-button.text': 'Invia'
};

});


//# sourceMappingURL=it.7ed56809.js.map
